import { ModalCustom } from "components/ModalCustom";
import { IDadosBancarios } from "../../../../interface/IDadosBancarios";
import {
  BodyModalDadosBancarios,
  ContainerDadosConta,
  TituloContainer,
} from "./style";
import { Col, Row } from "react-bootstrap";
import { OptionsBancos } from "features/core/pages/Financeiro/Constants/OptionsBancos";
import { StatusRecebeBoleto } from "../StatusRecebeBoleto";
import { formatarDinheiro } from "_utils/Money";

interface IProps {
  dados: IDadosBancarios;
  handleClose: () => void;
  show: boolean;
}

export function ModalDadosBancarios({ dados, handleClose, show }: IProps) {
  return (
    <ModalCustom
      centered
      handleClose={handleClose}
      show={show}
      title="Dados bancários do fornecedor"
      size="lg"
    >
      <BodyModalDadosBancarios>
        <TituloContainer>Dados do pagamento</TituloContainer>
        <ContainerDadosConta style={{ marginBottom: 24 }}>
          <Row style={{ marginBottom: 24 }}>
            <Col>
              <div>NF/Recibo</div>
              <div>
                <strong>{dados.numeroNfRecibo ?? "-"}</strong>
              </div>
            </Col>
            <Col>
              <div>Total a pagar</div>
              <div>
                <strong>
                  {dados.totalPagar
                    ? formatarDinheiro(Number(dados.totalPagar))
                    : "-"}
                </strong>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>Fornecedor</div>
              <div>
                <strong>{dados.nomeFornecedor ?? "-"}</strong>
              </div>
            </Col>
            <Col>
              <div>CNPJ</div>
              <div>
                <strong>{dados.cnpjFornecedor ?? "-"}</strong>
              </div>
            </Col>
          </Row>
        </ContainerDadosConta>
        <TituloContainer>Transferência bancária</TituloContainer>
        <ContainerDadosConta style={{ marginBottom: 24 }}>
          <Row style={{ marginBottom: 24 }}>
            <Col>
              <div>Banco</div>
              <div>
                <strong>
                  {dados.banco &&
                  OptionsBancos.some((option) => option.value === dados.banco)
                    ? OptionsBancos.filter(
                        (option) => option.value === dados.banco
                      )[0].label
                    : "-"}
                </strong>
              </div>
            </Col>
            <Col>
              <div>Agência</div>
              <div>
                <strong>{dados.agencia ?? "-"}</strong>
              </div>
            </Col>
          </Row>
          <Row style={{ marginBottom: 24 }}>
            <Col>
              <div>CNPJ</div>
              <div>
                <strong>{dados.cpfCnpjTitularContaTransferencia ?? "-"}</strong>
              </div>
            </Col>
            <Col>
              <div>Conta</div>
              <div>
                <strong>{dados.conta ?? "-"}</strong>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>Nome</div>
              <div>
                <strong>{dados.titularContaTransferencia ?? "-"}</strong>
              </div>
            </Col>
          </Row>
        </ContainerDadosConta>
        <TituloContainer>Pix</TituloContainer>
        <ContainerDadosConta style={{ marginBottom: 24 }}>
          <Row>
            <Col>
              <div>Nome</div>
              <div>
                <strong>{dados.titularContaPix ?? "-"}</strong>
              </div>
            </Col>
            <Col>
              <div>Chave Pix</div>
              <div>
                <strong>{dados.chavePix ?? "-"}</strong>
              </div>
            </Col>
          </Row>
        </ContainerDadosConta>
        <TituloContainer>Boleto</TituloContainer>
        <ContainerDadosConta>
          <Row>
            Status:{" "}
            {
              <StatusRecebeBoleto
                status={dados.boleto && dados.boleto === "SIM" ? "Sim" : "Não"}
              />
            }
          </Row>
        </ContainerDadosConta>
      </BodyModalDadosBancarios>
    </ModalCustom>
  );
}
